export const common = {
  nav: {
    overview: 'Overview',
    services: 'Services',
    industries: 'Industries',
    about: 'About Us',
    contact: 'Contact',
    getStarted: 'Get Started'
  },
  hero: {
    badge: 'Global IT Solutions Provider',
    title: 'Infrastructure That Powers Your Digital Future',
    subtitle: 'Your digital Swiss Army knife for comprehensive IT excellence. From complex infrastructure projects to cutting-edge audiovisual and surveillance solutions - we deliver professional results across every technology domain.',
    exploreSolutions: 'Explore Solutions',
    learnMore: 'Learn More'
  },
  services: {
    sectionTitle: 'OUR EXPERTISE',
    title: 'Comprehensive IT Solutions Tailored to Your Business',
    subtitle: 'We deliver customized IT services that address your unique challenges and drive your business forward.',
    learnMore: 'Learn more',
    itInfrastructure: {
      title: 'IT Infrastructure',
      description: 'Scalable network solutions designed to support your business growth. From server management to cloud integration, we build robust infrastructure that ensures reliability and performance.'
    },
    digitalisation: {
      title: 'Digitalisation',
      description: 'Transform your business processes with cutting-edge digital solutions. We help organizations modernize operations, improve efficiency, and stay competitive in the digital age.'
    },
    backup: {
      title: 'Backup Solutions',
      description: 'Comprehensive data protection and disaster recovery systems. Safeguard your critical business data with automated backups, secure storage, and rapid recovery capabilities.'
    },
    surveillance: {
      title: 'Surveillance Systems',
      description: 'Advanced security monitoring solutions tailored to your needs. Protect your assets with state-of-the-art surveillance technology and 24/7 monitoring capabilities.'
    },
    cybersecurity: {
      title: 'Cybersecurity',
      description: 'Protect your business from evolving cyber threats with comprehensive security solutions. We implement advanced threat detection, prevention systems, and security protocols to safeguard your digital assets.'
    },
    managedServices: {
      title: 'Managed Services',
      description: 'Focus on your core business while we handle your IT operations. Our managed services provide proactive monitoring, maintenance, and support to keep your systems running smoothly 24/7.'
    },
    projectManagement: {
      title: 'Project Management',
      description: 'Expert project management ensuring successful IT implementations. We deliver projects on time and within budget, coordinating all aspects from planning to deployment with proven methodologies.'
    },
    cisoService: {
      title: 'CISO-as-a-Service',
      description: 'Access executive-level security expertise without full-time costs. Our virtual CISO service provides strategic security leadership, compliance guidance, and risk management for your organization.'
    }
  },
  industries: {
    title: 'Industries We Serve',
    subtitle: 'Trusted by organizations across all sectors worldwide, delivering excellence in every project.',
    industry: {
      name: 'Industry',
      description: 'Manufacturing and production facilities'
    },
    retail: {
      name: 'Retail',
      description: 'Stores and e-commerce platforms'
    },
    healthcare: {
      name: 'Healthcare',
      description: 'Hospitals and medical centers'
    },
    government: {
      name: 'Government',
      description: 'Public sector organizations'
    }
  },
  about: {
    sectionTitle: 'ABOUT US',
    title: 'Your Trusted IT Partner Since Day One',
    description: 'Based in West Flanders, Belgium, we are a leading IT services provider with a global reach. Our team of certified professionals delivers innovative solutions across all industries - from manufacturing and retail to healthcare and government sectors.',
    mission: 'Our mission is to empower businesses with reliable, secure, and scalable IT infrastructure that drives digital transformation and operational excellence.',
    gdprCompliant: 'GDPR Compliant',
    support247: '24/7 Support'
  },
  cta: {
    title: 'Ready to transform your IT infrastructure? Let\'s build something exceptional together.',
    button: 'Schedule Consultation'
  },
  contact: {
    sectionTitle: 'GET IN TOUCH',
    title: 'Let\'s Discuss Your IT Needs',
    subtitle: 'Fill out the form below and we\'ll get back to you within 24 hours',
    subtitleShort: 'Fill out the form below and we\'ll get back to you within 24 hours',
    form: {
      name: 'Full Name',
      email: 'Email Address',
      company: 'Company Name',
      phone: 'Phone Number',
      message: 'Message',
      verification: 'Verification: What is',
      verificationPlaceholder: 'Enter the answer',
      required: '*',
      namePlaceholder: 'John Doe',
      emailPlaceholder: 'john@company.com',
      companyPlaceholder: 'Your Company',
      phonePlaceholder: '+32 123 45 67 89',
      messagePlaceholder: 'Tell us about your IT needs...',
      charactersCount: 'characters',
      submit: 'Send Message',
      sending: 'Sending...',
      successMessage: 'Thank you! Your message has been sent successfully. We\'ll get back to you soon.',
      errorMessage: 'Please answer the verification question correctly and try again.'
    }
  },
  footer: {
    description: 'Leading IT services provider delivering innovative solutions for infrastructure, digitalisation, backup, and surveillance worldwide.',
    solutions: 'Solutions',
    copyright: '© 2025 IT Services. All rights reserved.',
    poweredBy: 'Powered by Readdy',
    privacy: 'Privacy Policy',
    terms: 'Terms of Service'
  },
  cookies: {
    title: 'We value your privacy',
    description: 'We use cookies to enhance your browsing experience, serve personalized content, and analyze our traffic. By clicking "Accept All", you consent to our use of cookies.',
    customize: 'Customize',
    acceptAll: 'Accept All',
    rejectAll: 'Reject All',
    savePreferences: 'Save Preferences',
    settingsTitle: 'Cookie Preferences',
    necessary: 'Necessary Cookies',
    alwaysActive: 'Always Active',
    necessaryDesc: 'These cookies are essential for the website to function properly. They enable basic features like page navigation and access to secure areas.',
    analytics: 'Analytics Cookies',
    analyticsDesc: 'These cookies help us understand how visitors interact with our website by collecting and reporting information anonymously.',
    marketing: 'Marketing Cookies',
    marketingDesc: 'These cookies are used to track visitors across websites to display relevant advertisements and marketing campaigns.'
  }
};
